import React, {Component} from "react";
import {Modal} from "@frostbyte-technologies/frostbyte-tailwind";
import {request} from "../../../utils/request";
import {toDollars} from "@frostbyte-technologies/frostbyte-core/dist/utils/util";
import {withRouter} from "../../../utils/navigation";

class SendInvoiceModal extends Component {
  state = {invoice: null};

  open(invoice = null) {
    this.setState({invoice}, () => {
      this.modal.open();
    });
  }

  async sendInvoice() {
    const {invoice} = this.state;

    const serverInvoice = await request("invoices/" + invoice.ID + "/send-quote", "POST", {});

    this.props.updateState(serverInvoice);
    this.modal && this.modal.close();
  }

  render() {
    const {invoice} = this.state;

    const total = invoice?.TICKET?.ITEMS?.reduce((accum, item) => accum + item.TOTAL, 0);

    return (
      <Modal
        hideClose
        deleteOnClick={() => this.modal.close()}
        deleteType="gray"
        deleteLabel="Cancel"
        buttons={[
          {
            label: "Send Now",
            ref: (e) => (this.sendButton = e),
            onClick: () => this.sendInvoice(),
          },
        ]}
        label="Send Quote"
        ref={(e) => (this.modal = e)}
      >
        <div className="font-medium">
          Send quote for <span className="font-bold">${toDollars(total)}</span> to{" "}
          <span className="font-bold">
            {invoice?.CONTACT?.FIRST_NAME} {invoice?.CONTACT?.LAST_NAME}
          </span>
        </div>

        <div className="mt-4 text-sm text-gray-700">
          Would you like to <span className="font-bold">Resend Quote</span> for approval and notify the
          customer immediately?
        </div>
      </Modal>
    );
  }
}

export default withRouter(SendInvoiceModal);
